import { FoodsIllustrations } from "@foodpilot/foods";
import { Dialog, Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { BaseFooter } from "../Footers/BaseFooter";

export type ConfirmationModalData = {
    isOpen: boolean;
    errors: ReactNode;
};

type SsqPostDeletionWarningDialogProps = {
    confirmationData: ConfirmationModalData;
    setConfirmationData: (isOpen: ConfirmationModalData) => void;
    onConfirm: () => void;
};
export const DataDeletionWarningDialog = (props: SsqPostDeletionWarningDialogProps) => {
    const { confirmationData, setConfirmationData, onConfirm } = props;
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <Dialog
            open={confirmationData.isOpen}
            onClose={() => {
                setConfirmationData({
                    ...confirmationData,
                    isOpen: false,
                });
            }}
            fullWidth
            maxWidth={"md"}
        >
            <Stack gap={theme.spacing(2)} alignItems="center" padding={theme.spacing(4)}>
                <Stack
                    flexDirection={"row"}
                    alignItems={"center"}
                    justifyContent={"left"}
                    gap={theme.spacing(2)}
                    width={"100%"}
                >
                    <FoodsIllustrations height={60} width={60} illustration="underConstruction" />
                    <Stack justifyContent={"center"}>
                        <Typography variant={"body-bold"}>
                            {t("form.data_deletion_warning.title", "Beware, you may delete unexpected data")}
                        </Typography>
                    </Stack>
                </Stack>
                <Stack gap={theme.spacing(2)} width={"100%"}>
                    {confirmationData.errors}
                </Stack>
            </Stack>
            <BaseFooter
                onCancelAction={() => {
                    // For now, nothing;
                    setConfirmationData({
                        ...confirmationData,
                        isOpen: false,
                    });
                }}
                onConfirmAction={() => {
                    onConfirm();
                    setConfirmationData({
                        ...confirmationData,
                        isOpen: false,
                    });
                }}
                cancelText={t("primarydialog.cancel")}
                validateText={t("primarydialog.validate")}
            />
        </Dialog>
    );
};
